document.addEventListener("DOMContentLoaded", function () {
    const sports = Array.from(document.querySelectorAll(".toggle-sport"));

    function getSelectedSports() {
        return sports
            .filter(el => el.getAttribute("aria-checked") === "true")
            .map(el => el.getAttribute("data-sports"));
    }

    function renderCommunities() {
        const selected = getSelectedSports();
        const allCommunityDivs = document.querySelectorAll(".community");

        allCommunityDivs.forEach(div => div.classList.add("Disable"));

        selected.forEach(sport => {
            const el = document.querySelector(`.${sport}-community`);
            if (el) el.classList.remove("Disable");
        });

        if (selected.length === 0) {
            allCommunityDivs.forEach(div => div.classList.remove("Disable"));
        }
    }

    function toggleSport(el) {

        sports.forEach(btn => {
            btn.setAttribute("aria-checked", "false");
            btn.classList.remove("active");
        });

        el.setAttribute("aria-checked", "true");
        el.classList.add("active");

        renderCommunities();
    }


    sports.forEach(el => {
        el.addEventListener("click", () => toggleSport(el));

        el.addEventListener("keydown", (evt) => {
            const code = evt.code;

            if (code === "Space" || code === "Enter") {
                evt.preventDefault();
                toggleSport(el);
            }

            if (code === "ArrowLeft" || code === "ArrowRight") {
                evt.preventDefault();
                const index = sports.indexOf(el);
                const nextIndex = code === "ArrowLeft"
                    ? (index - 1 + sports.length) % sports.length
                    : (index + 1) % sports.length;
                sports[nextIndex].focus();
            }
        });
    });
});
